import {Circle} from 'konva/lib/shapes/Circle'
export const createAttachAnchor = (x, y, node, position) => {
  const anchor = new Circle({
    x,
    y,
    name: 'attach',
    radius: 2,
    stroke: 'red',
    fill: '#ddd',
    strokeWidth: 2,
    draggable: false,
    nodeId: node.id(),
    location: position,
    visible: false,
    shapeType: 'anchor'
  })
  anchor.x(x)
  anchor.y(y)
  if (!node.getAttr('anchors')) {
    node.setAttr('anchors', [])
  }
  node.setAttr('anchors', [...node.getAttr('anchors'), anchor])
  const layer = node.getLayer()
  layer.add(anchor)
  layer.batchDraw()
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createAttachAnchor.js